module.exports = __webpack_public_path__ + "img/gem.536a633a.svg";